const Pricing = {

    // FIELDS
    "department": "Department",
    "location": "Location",
    "component": "Component",
    "equipment": "Equipment",
    "price": "Price",
    "enter_price": "Enter Price",
    "search": "Search",

    // PAGE HEADER
    "pricing": "Pricing",

    // TABLE HEADER
    "table_department": 'DEPARTMENT',
    "table_location": 'LOCATION',
    "table_component": 'COMPONENT',
    "table_equipment": 'EQUIPMENT',
    "table_make": "MAKE",
    "table_new_part_number": "NEW PART NUMBER",
    "table_old_part_number": "OLD PART NUMBER",
    "table_km_item_code": "KM ITEM CODE",
    "table_price": "PRICE",

    // MESSAGES
    "save_success": "Price saved successfully",

}

export default Pricing;